import ReactOnRails from 'react-on-rails';
import GuidePage from "../bundles/Guides/GuidePage";
import Guides from "../bundles/Guides";
import '../src/styles/guides.sass';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({ Guides, GuidePage });
